import { ScreenDimensionsComponent } from '../../shared/components/screen-dimension-calculator/screen-dimension-component';
import { Component, inject, computed, signal, Renderer2, ViewChild, AfterViewInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { CommonModule, Location } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { HeaderState } from '../../@core/services/header-state.service';
import { GlobalLoaderComponent } from 'src/app/app-component/global-loader-component';
import { ToastContainerComponent } from 'src/app/app-component/toast-container.component';
import { StoragePrefix } from '@core/constant';
import { SignupStepService } from 'src/app/auth/signup/signup-step.service';
import { StorageService } from 'src/app/utils';
import { LanguageModalComponent } from 'src/app/shared/components/language-modal.component/language-modal.component';
import { LoginStepService } from 'src/app/auth/login-layout/login-layout-step.service';
import { PortalHostDirective } from 'src/app/shared/directives/portal-host-directive';
import { PortalService } from '@core/services/portal.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-auth-layout-pwa',
  imports: [
    RouterOutlet,
    TranslateModule,
    CommonModule,
    GlobalLoaderComponent,
    ToastContainerComponent,
    LanguageModalComponent,
  ],
  templateUrl: './auth-layout-pwa.component.html',
  styleUrls: ['./auth-layout-pwa.component.scss'], // Corrected to styleUrls
})
export class AuthLayoutPWAComponent implements AfterViewInit, OnDestroy {
  @ViewChild(PortalHostDirective, { static: false }) portalHost!: PortalHostDirective;
  _storage = inject(StorageService);
  _portal = inject(PortalService);
  private removeResizeListener?: () => void;
  constructor(
    private location: Location,
    public translate: TranslateService,
    public router: Router,
    private renderer: Renderer2
  ) { } // Inject TranslateService in the constructor

  headerH = 220; // starting height
  private readonly minH = 180; // clamp range
  private readonly maxH = 360;
  private readonly k = 0.25; // growth rate per px scrolled
  screenWidth = signal(window.innerWidth);
  screenHeight: number = 0;
  public screenDimensionService = inject(ScreenDimensionsComponent);

  // use directly in template

  private header = inject(HeaderState);
  _signupStep = inject(SignupStepService);
  _loginStep = inject(LoginStepService);


  isLangPopUpVisible = signal(false);
  title = computed(() => this.header.title());
  wave = computed(() => this.header.wave());
  ngOnInit() {
    this.removeResizeListener = this.renderer.listen('window', 'resize', this.onResize.bind(this));
    // const screenDimension =
    //   this.screenDimensionService.updateScreenDimensions();
    // 
    // this.screenWidth.set(screenDimension.width);
    // 
    const saved = this._storage.get(StoragePrefix.LANGUAGE) || 'en';
    this.translate.setDefaultLang('en');
    this.translate.use(saved);
    document.dir = saved === 'ar' ? 'rtl' : 'ltr';
    try {
      document.documentElement.lang = saved;
    } catch { }
  }

  ngAfterViewInit() {
    if (this.portalHost) {
      this._portal.registerHost(this.portalHost);
    } else {
      console.warn('Portal host not found');
    }
  }

  ngOnDestroy(): void {
    this.removeResizeListener?.();
  }

  onResize(event: Event): void {
    this.screenWidth.set(window.innerWidth);
  }
  goBack() {
    this.location.back(); // Navigate back to the previous page
  }
  switchLang(arg: any) {
    const lang = typeof arg === 'string' ? arg : arg?.target?.value;
    if (!lang) return;
    this.translate.use(lang);
    document.dir = lang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lang;
    this._storage.set(StoragePrefix.LANGUAGE, lang);
  }

  get currentLang(): string {
    const lang = this._storage.get(StoragePrefix.LANGUAGE || 'en');
    return lang
    // return (
    //   this.translate.currentLang || this.translate.getDefaultLang() || 'en'
    // );
  }
  openLanguagePopUp() {
    this.isLangPopUpVisible.set(true)
  }
}
